/** Customer CommodityBid app (bid creation). */
export const COMMODITYBID_EXTERNAL_URL = 'https://commoditybid.demaxtore.com/';

/** CommodityBid production request form (customer dashboard CTA). */
export const COMMODITYBID_CREATE_REQUEST_URL =
  'https://commoditybid.demaxtore.com/panel/productionRequests/create';
